import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContractType, PostCjResponseResultModel, PredictZipCodeModel } from '../../models';
import { CustomizedHttpService } from '../base/customized-http.service';
import { HttpParams } from '@angular/common/http';
import { LocalDataCacheService } from '..';

@Injectable({
  providedIn: 'root'
})
export class CustomerJourneyService {

  constructor(private httpService: CustomizedHttpService, private localDataStorage: LocalDataCacheService, @Inject('BASE_URL') private originUrl: string) { }



  postCJData(model: ContractType): Observable<PostCjResponseResultModel> {
    let payload = {
      contractType: model,
      isMobileDevice: this.localDataStorage.getSessionStorage().getItem("MobileTracking") == "MobileTrackingDevice"
    }
    return this.httpService.post<any, PostCjResponseResultModel>(`${this.originUrl}CustomerJourney/PostCjData/`, { CJReqStr: JSON.stringify(payload) });
  }

  predictZipCode(zipCodeInput: string): Observable<PredictZipCodeModel> {
    return this.httpService.getByQuery<PredictZipCodeModel>(`${this.originUrl}CustomerJourney/predictZipCode`, new HttpParams().set("zipCodeInput", zipCodeInput));
  }

}
